import React from 'react'

// Third Party
import styled from 'styled-components'

const StyledInput = styled.input`
  width: 100%;
  padding: 10px 10px;

  :focus {
    outline: ${(props) => props.theme.color.contrast} auto 2px;
  }
`

const PriceFilter = ({
  title,
  onChange,
  className,
  activeFilterType
}) => {
  const value = activeFilterType !== 0 ? `${activeFilterType}` : null

  return (
    <div className={`filter-wrapper px-0 ${className && `${className}`}`}>
      <StyledInput
        type="number"
        onChange={(e) => onChange(e.target.value)}
        placeholder={title}
        value={value}
      />
    </div>
  )
}

export default PriceFilter
